import { useMemo, useRef } from "react";

import { debounce } from "lodash";

const useDebounce = (
  func: (...args: any) => any,
  wait = 0,
  options: { leading?: false; maxWait?: number; trailing?: boolean } = {
    leading: false,
    trailing: true,
  }
) => {
  const debounceRef = useRef<ReturnType<typeof debounce>>();

  return useMemo(() => {
    if (debounceRef.current) {
      debounceRef.current.cancel();
    }
    debounceRef.current = debounce(func, wait, options);
    return debounceRef.current;
  }, [func, wait, options.leading, options.maxWait, options.trailing]);
};

export default useDebounce;
